import React from 'react';
import ReactMarkdown from 'react-markdown';
import styles from './ChatMessage.module.css';

function ChatMessage({ content }) {
  console.log('render ChatMessage', content);
  return (
    <div className={styles.chatMessage}>
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
}

export default ChatMessage;
